export default "__VITE_ASSET__a66ca98b__"